import Link from 'next/link';
import settings from '@/settings';
import i18n from '@/settings/i18n';

const t = i18n.init('shared');

const SellYourDevice = () => {
  if (
    !['reebelo-dev', 'reebelo-us', 'reebelo-au', 'reebelo-nz'].includes(
      settings.store,
    )
  ) {
    return null;
  }

  return (
    <Link
      href="/buyback"
      prefetch={false}
      className="flex h-7 items-center justify-center rounded-full border border-gray-700 px-3 text-xs font-medium"
    >
      <span className="whitespace-nowrap">{t`Sell Your Device`}</span>
    </Link>
  );
};

export default SellYourDevice;
